var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionShoppingCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-824.000000, -1706.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Shopping-cart",
    transform: "translate(824.000000, 1706.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3474672,25.7566982 C13.5004828,25.7566982 14.4354955,26.706767 14.4354955,27.8783491 C14.4354955,29.0499312 13.5004828,30 12.3474672,30 C11.1944516,30 10.259439,29.0499312 10.259439,27.8783491 C10.259439,26.706767 11.1944516,25.7566982 12.3474672,25.7566982 Z M23.7138212,25.7566982 C24.8668368,25.7566982 25.8018495,26.706767 25.8018495,27.8783491 C25.8018495,29.0499312 24.8668368,30 23.7138212,30 C22.5608056,30 21.6257929,29.0499312 21.6257929,27.8783491 C21.6257929,26.706767 22.5608056,25.7566982 23.7138212,25.7566982 Z M3.2930446,2 C4.98506752,2 6.20608405,2.43794614 6.84309268,4.52301685 L7.07609584,5.3724901 L12.3471672,22.5743235 C10.7381454,22.500147 8.88012027,21.9737987 8.29611236,20.0624839 L3.7950514,5.37452233 L3.78305124,5.37452233 C2.09102832,5.37452233 0.870011783,4.9365762 0.233003156,2.8525216 L0,2.00304835 L3.2930446,2 Z M29.1711951,7.72215751 C31.2382231,7.72215751 32.5422408,9.3957011 31.7802304,11.5254809 L31.7802304,11.5254809 L27.393171,22.5737138 L14.8650013,22.5737138 L10.2069382,7.72418974 L10.2089383,7.72215751 Z",
    id: 153
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionShoppingCart);
export default __webpack_public_path__ + "static/media/navigation-and-action-shopping-cart.5760c054.svg";
export { ForwardRef as ReactComponent };